import { BasicItemResponse } from "../../../../responses/basicResponses";
import { CustomPanelTypeStatus, ICustomCornerType } from "../../../../responses/customPanelTypes";
import repo from "../../../../Repository";

export class CustomCornerTypeUploader {
    async uploadCustomComponent(file: File, assemblyFileName: string): Promise<BasicItemResponse<ICustomCornerType>> {
        const createNewCustomComponentResponse = await repo.createCustomCornerType(file.name);

        if (!createNewCustomComponentResponse.isSuccess) {
            return { isSuccess: false, message: createNewCustomComponentResponse.message, item: null };
        }

        const { id, uploadUrl } = createNewCustomComponentResponse.item;

        const uploadFileResult = await repo.uploadFile(file, uploadUrl);

        if (!uploadFileResult.isSuccess) {
            return { isSuccess: false, message: uploadFileResult.message, item: null };
        }

        const startComponentProcessingResponse = await repo.startCustomCornerTypeProcessing(id, assemblyFileName);

        if (!startComponentProcessingResponse.isSuccess) {
            return { isSuccess: false, message: startComponentProcessingResponse.message, item: null };
        }

        return this.waitForProcessingDone(id);
    }

    private waitForProcessingDone(id: string): Promise<BasicItemResponse<ICustomCornerType>> {
        return new Promise<BasicItemResponse<ICustomCornerType>>(resolve => {
            const timeout = 5000;

            const periodicalCheck = async () => {
                const response = await repo.findCustomCornerType(id);

                if (!response.isSuccess || response.item.status === CustomPanelTypeStatus.Created) {
                    setTimeout(periodicalCheck, timeout);

                    return;
                }

                resolve(response);
            };

            setTimeout(periodicalCheck, timeout);
        });
    }
}
